import React from 'react';
import styled from 'styled-components';
import ReactHtmlParser, { convertNodeToElement } from 'react-html-parser';
import { Icon } from '@codex/icons';
import PropTypes from 'prop-types';

const StyledListIcon = styled(Icon)`
  color: ${({ theme }) => theme.colors.buy.default};
  && {
    width: 16px;
    height: 10px;
  }
`;

const ListItemWrapper = styled.p`
  display: flex;
`;

const ListIconWrapper = styled.span`
  padding-right: 15px;
`;

const isNodeLink = (node) => node.type === 'tag' && node.name === 'a';

const isNodeList = (node) => node.type === 'tag' && (node.name === 'ul' || node.name === 'ol');

const isNodeHeader = (node) => node.type === 'tag' &&
  (node.name === 'h1' || node.name === 'h2' || node.name === 'h3' || node.name === 'h4');

const isNodeListItem = (node) => node.type === 'tag' && node.name === 'li';

const isNodeIconElement = (node) => node.type === 'tag' && (node.name === 'i' || node.name === 'span');

const hasNodeClass = (node, className) => 'attribs' in node && 'class' in node.attribs &&
  node.attribs.class.indexOf(className) !== -1;

const isNodeText = (node) => node.type === 'text';

const isNodeIcon = (node) => {
  if (!isNodeIconElement(node)) {
    return false;
  }
  return hasNodeClass(node, 'icon-li');
};

const getNodeIcon = (node, key) => {
  if (hasNodeClass(node, 'icon-ok')) {
    return <ListIconWrapper key={key}><StyledListIcon icon={'Tick'} /></ListIconWrapper>;
  }
  return null;
};

const getNewListItem = (node, index) => {
  const content = [];
  for (let i = 0; i < node.children.length; i++) {
    const childrenNode = node.children[i];
    if (isNodeIcon(childrenNode)) {
      content.push(getNodeIcon(childrenNode, i));
    } else if (isNodeText(childrenNode)) {
      content.push(childrenNode.data);
    }
  }

  return (
    <ListItemWrapper key={index}>
      {content}
    </ListItemWrapper>
  );
};

const getNewList = (node) => {
  const items = [];
  for (let i = 0; i < node.children.length; i++) {
    const childrenNode = node.children[i];
    if (isNodeListItem(childrenNode)) {
      items.push(getNewListItem(childrenNode, i));
    }
  }
  return items;
};

const getConvertedList = (node, index) => <div key={index}>{getNewList(node)}</div>;

const getConvertedHeader = (node, index) => {
  node.name = 'strong';
  return convertNodeToElement(node, index, transform);
};

const getConvertedLink = (node, index) => {
  node.attribs.target = '_blank';
  return convertNodeToElement(node, index, transform);
};

function transform(node, index) {

  if (isNodeHeader(node)) {
    return getConvertedHeader(node, index);
  }

  if (isNodeList(node)) {
    return getConvertedList(node, index);
  }

  if (isNodeLink(node)) {
    return getConvertedLink(node, index);
  }

  return convertNodeToElement(node, index, transform);
}

class InformationTooltipRenderer {
  static getRenderedHtml(html) {
    return ReactHtmlParser(html, { decodeEntities: true, transform: transform });
  }
}

InformationTooltipRenderer.propTypes = {
  html: PropTypes.string.isRequired
};

export default InformationTooltipRenderer;
